import { buildColumnBarOptions } from '@aytm/app/stats/page/question-views/components/charts/highcharts/lib/columnBarConfig'
import { wireMoEEvents } from '@aytm/app/stats/page/question-views/components/charts/highcharts/lib/marginOfError'

// A value label stands 4px above its column on a 12px line. The plot's top is fixed and the legend
// above it may run to its full height (three rows, or two and the pager), so the tallest column's
// label only stays clear of the legend if the plot starts one label lower.
const VALUE_LABEL_ROOM = 16

export const buildColumnOptions = props => {
  const result = buildColumnBarOptions(props)
  if (!result) return null

  result.options.chart.type = 'column'
  result.options.chart.defaultSeriesType = 'column'
  result.options.plotOptions.column = { groupPadding: 0.05 }

  const margin = result.options.chart.margin
  if (result.options.plotOptions.series?.dataLabels?.enabled && Array.isArray(margin)) {
    result.options.chart.margin = [margin[0] + VALUE_LABEL_ROOM, ...margin.slice(1)]
  }

  wireMoEEvents(result.options, props) // MoE hover overlay (no-op without props.moeController)

  return result
}
